import { Component, OnInit, HostListener } from '@angular/core';
import { PhotographerNetworkService, PhotographerNetwork } from '../photographer-network.service';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  photographerList: PhotographerNetwork[] = [];
  isLoggedUser: boolean;

  constructor(private http: HttpClient, private cookieService: CookieService, private photographerNetworkService: PhotographerNetworkService) {

  }

  ngOnInit() {
    this.isLoggedUser = false;
    if (this.cookieService.get('MLS-AUTH').length > 0)
      this.isLoggedUser = true;
    this.photographerNetworkService.getPhotographerNetwork().subscribe(res => {
      console.log(res);
      this.photographerList = res;
    });
  }
  closeWindow() {
    window.close();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll($event: Event) {
    let scrollElem = $event.srcElement['scrollTop'];
    if (scrollElem == 0) {
      document.getElementById('mlslogin-scroll').classList.remove('shadow-on');
    } else {
      document.getElementById('mlslogin-scroll').classList.add('shadow-on');
    }
  }
}
